import * as classnames from 'classnames/bind'
import * as React from 'react'
import { ChangeEvent, FC, useEffect, useRef, useState } from 'react'
import { isEmpty } from 'lodash'
import styles from './form_field.module.scss'

type Props = {
  id: string
  isActive: boolean
  label: string
  name: string
  required: boolean
  value: string
  onChange: (string: string) => void
  readOnly: boolean
  icon?: React.ReactElement
}

const cx = classnames.bind(styles)
export const FormField: FC<Props> = ({ id, isActive, label, name, required, value, onChange, icon, readOnly }) => {
  const [isFocused, setFocusInput] = useState(false)
  const inputRef = useRef(null)

  useEffect(() => {
    if (isEmpty(value)) {
      inputRef.current.value = ''
    }
  }, [value])

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    onChange(value)
  }

  return (
    <div className={styles.formGroup}>
      <label
        className={cx(styles.label, {
          labelAbove: isFocused || !isEmpty(value),
          labelFocused: isFocused || isActive
        })}
        htmlFor={id}
      >
        {label}
      </label>
      <div className={styles.formGroupContainer}>
        <input
          ref={inputRef}
          type="text"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          className={styles.formField}
          value={value}
          name={name}
          id={id}
          required={required}
          readOnly={readOnly}
          onChange={e => handleChange(e)}
          onFocus={() => setFocusInput(true)}
          onBlur={() => setFocusInput(false)}
        />

        <label
          className={cx(styles.formLabel, {
            formLabelDefault: !isFocused,
            formLabelFocused: isFocused
          })}
          htmlFor={id}
        >
          {icon}
        </label>
        <div
          className={cx(styles.focusBar, {
            focusBarFocused: isFocused || isActive
          })}
        />
      </div>
    </div>
  )
}
